import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReAuth } from "./config";

export const jumboMediaAPI = createApi({
  reducerPath: "jumboMediaAPI",
  baseQuery: baseQueryWithReAuth,
  tagTypes: [
    "Advertiser",
    "Brand",
    "ftpSettings",
    "User",
    "Projects",
    "ActivityLog",
    "Recipients",
    "Clients",
    "Translations",
    "MailTemplates",
    "HouseNumbers",
    "Versions",
    "DeliveryServiceDetails",
    "ReDeliveryOrders",
    "Report",
    "ChargeHistory",
    "ServicePackages",
    "NotificationSetting",
    "VideoGuides",
  ],
  endpoints: () => ({}),
  keepUnusedDataFor: 0,
});
